import { CommonModule, NgClass } from "@angular/common";
import {
  Component,
  HostListener,
  OnInit,
  ChangeDetectorRef,
  Inject,
} from "@angular/core";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";

import { MatMenuModule } from "@angular/material/menu";
import { MatButtonModule } from "@angular/material/button";

import { ToastrService } from "ngx-toastr";

import { AuthenticationService } from "../../services/auth.service";
// import { CustomizerSettingsService } from "../../customizer-settings/customizer-settings.service";
import { MessagePanelService } from "../../services/message-panel.service";
import { ToggleService } from "../sidebar/toggle.service";
import { CustomizerSettingsService } from "../../customizer-settings/customizer-settings.service";
import { MenuSearchDialogComponent } from "./menu-filter-dialog/menu-filter-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { MenuStateService } from "../../services/menu.service";
import { LockService } from "../../services/lock.service";

@Component({
  selector: "app-header",
  standalone: true,
  imports: [NgClass, MatMenuModule, CommonModule, MatButtonModule, RouterLink],
  templateUrl: "./header.component.html",
  styleUrl: "./header.component.scss",
})
export class HeaderComponent implements OnInit {
  // isSidebarToggled
  isSidebarToggled = false;

  // isToggled
  isToggled = false;
  displayName: any;
  currentUserData: string | null;
  userName: any;
  userType: any;
  unreadCount: number = 0;
  UserTypeDataId: any;

  constructor(
    private toggleService: ToggleService,
    public themeService: CustomizerSettingsService,
    private authenticationService: AuthenticationService,
    private messagePanelService: MessagePanelService,
    public toastrService: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
    private menuState: MenuStateService,
    private sessionLock: LockService,
  ) {
    this.toggleService.isSidebarToggled$.subscribe((isSidebarToggled) => {
      this.isSidebarToggled = isSidebarToggled;
    });
    this.themeService.isToggled$.subscribe((isToggled) => {
      this.isToggled = isToggled;
    });

    this.currentUserData = sessionStorage.getItem("currentUser");
    let currentUser: any | null = null;
    if (this.currentUserData && this.currentUserData) {
      try {
        currentUser = JSON.parse(this.currentUserData) as any;
      } catch (error) {}
    }
    this.displayName = currentUser ? currentUser?.displayName : null;
    this.userName = currentUser ? currentUser?.username : null;
    this.userType = currentUser ? currentUser?.userType : null;
    this.UserTypeDataId = currentUser ? currentUser?.userId : null;
    console.log("Logged in user ID:", this.UserTypeDataId);
  }

  ngOnInit(): void {
    console.log("Logged in user ID:", this.UserTypeDataId);
    this.messagePanelService.connectWebSocket(this.UserTypeDataId);

    this.loadUnreadMessages();

    this.messagePanelService.onUnreadStats().subscribe((stats) => {
      console.log("Unread stats:", stats);
      this.unreadCount = stats.unreadMessages;
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy(): void {
    // if (this.intervalId) {
    //   clearInterval(this.intervalId);
    // }
  }

  // Burger Menu Toggle
  toggle() {
    this.toggleService.toggle();
  }

  loadUnreadMessages(): void {
    this.messagePanelService.fetchUnreadMessages().subscribe({
      next: (res) => {
        this.unreadCount = res?.unreadMessages || 0;
      },
      error: (err) => console.error("Failed to fetch unread messages", err),
    });
  }
  @HostListener("document:keydown.control.k", ["$event"])
  openShortcut(event: Event) {
    const keyboardEvent = event as KeyboardEvent;
    keyboardEvent.preventDefault();
    this.openMenuSearch();
  }

  // Header Sticky
  isSticky: boolean = false;
  @HostListener("window:scroll", [])
  checkScroll() {
    const scrollPosition =
      window.scrollY ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    if (scrollPosition >= 50) {
      this.isSticky = true;
    } else {
      this.isSticky = false;
    }
  }
  toProfile() {
    this.router.navigate(["./my-profile"], { relativeTo: this.route });
  }

  // Dark Mode
  toggleTheme() {
    this.themeService.toggleTheme();
  }
  openMenuSearch() {
    if (this.sessionLock.isLocked()) {
      return;
    }

    if (this.dialog.openDialogs.length > 0) {
      return;
    }
    document.body.classList.add("dialog--open");
    const ref = this.dialog.open(MenuSearchDialogComponent, {
      width: "525px",
      maxHeight: "700px",
      autoFocus: true,
      disableClose: false,
      position: {
        top: "60px",
      },
      data: {
        menuItems: this.menuState.getMenuSnapshot(), // from sidebar or shared service
      },
    });

    ref.afterClosed().subscribe((route: any) => {
      if (route) {
        this.router.navigateByUrl(route);
        console.log("Navigated route: ", route);
      }
      document.body.classList.remove("dialog--open");
    });
  }

  logout() {
    this.authenticationService.logout();
    this.toastrService.success("You were loged out.!");

    this.router.navigate(["/authentication"]);
  }
}
